import { render, staticRenderFns } from "./SettlementForm.vue?vue&type=template&id=15a89704&"
import script from "./SettlementForm.vue?vue&type=script&lang=js&"
export * from "./SettlementForm.vue?vue&type=script&lang=js&"
import style0 from "./SettlementForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports